// extracted by mini-css-extract-plugin
export default {"textMargin":"app-portainer-components-Tip-TextTip-TextTip-module__text-margin"};